import { useLocalStorage } from "@rehooks/local-storage";
import { TENANT_KEY } from "../constants";

/**
 * Reads the current tenant and re-renders when it changes.
 *
 * The library parses the stored value as JSON first, so a subdomain of only
 * digits comes back as a number. Callers expect a string. Writes go through
 * `writeTenant` in `logic/tenant-storage.ts`, so this hook returns no writer.
 */
export function useTenantSetting(): string | null {
  const [value] = useLocalStorage<string>(TENANT_KEY);

  return value == null ? null : String(value);
}
